export default {
    data: () => ({
        orderCoachColumns: [
            {
                label: "id",
                field: "id",
                sortable: true,
                required: true
            }, {
                label: "order status",
                field: "order_status.description",
                required: true,
                sortable: true
            }, {
                label: "order date",
                field: "created_at",
                required: true,
                sortable: true
            }, 
            {
                label: "model",
                field: "lending_kit_model.description",
                required: true
            }, {
                label: "sku code",
                field: "lending_kit_color.sku",
                required: true
            }, {
                label: "sku description",
                field: "lending_kit_color.description",
                required: true
            }, {
                label: "image",
                field: "lending_kit_color.image",
                required: true
            },
            {
                label: "lending point",
                field: "lending_point.description",
            }, {
                label: "lending kit",
                field: "lending_kit.identifier",
            }, {
                label: "first name",
                field: "firstname",
                sortable: true,
                required: true
            }, {
                label: "last name",
                field: "lastname",
                sortable: true
            }, {
                label: "birth date",
                field: "birthdate",
                sortable: true
            }, {
                label: "gender",
                field: "gender",
                sortable: true
            }, {
                label: "cell phone",
                field: "phone",
                sortable: true
            }, {
                label: "email",
                field: "email",
                sortable: true
            }, {
                label: "delivery",
                field: "delivery"
            }, {
                label: "is sold",
                field: "is_sold"
            }, {
                label: "device",
                field: "device"
            }, {
                label: "no sold reason",
                field: "no_sold_reason.description"
            }, {
                label: "lending start date",
                field: "start_lending_at"
            }, {
                label: "lending end date",
                field: "end_lending_at"
            }, {
                label: "address",
                field: "address"
            }, {
                label: "address 2",
                field: "address_2"
            }, {
                label: "zip code",
                field: "zipcode"
            }, {
                label: "city",
                field: "city"
            }, {
                label: "contact coming from",
                field: "origin.description"
            }, {
                label: "follow up",
                field: "follow_up",
                sortable: true,
                align: "center"
            }, {
                label: "referer",
                field: "referer"
            }, {
                label: "observations",
                field: "observations"
            },
            {
                label: "dcs id",
                field: "iqos_user_id",
                sortable: true
            },
            {
                label: "group updated",
                field: "iqos_group_updated",
                sortable: true
            },
            {
                label: "sell order number",
                field: "sell_order_number",
                sortable: true
            },
            {
                label: "phone",
                field: "phone",
                sortable: true,
                required: true
            },
            {
                label: "days count",
                field: "days_count",
                sortable: true,
                required: true
            },
            {
                label: "contact success count",
                field: "contact_success_count",
                required: true,
            },
            {
                label: "last contact date",
                field: "last_contact_date",
                required: true,
            },
            {
                label: "comments",
                field: "last_comment",
                required: true,
            }


        ]
    })
}


// WEBPACK FOOTER //
// ./resources/assets/js/pages/orderCoachColumns.js